module.exports = __webpack_public_path__ + "img/saison.2208da56.png";